module.exports = __webpack_public_path__ + "img/rules_17.210a50de.png";